import type { CustomDimensions } from '../types';
import { convertObjectByDictionaries } from '../utils/objects';
import {
  customDimensionToCustomParamDictionary,
  customDimensionToUserPropertyDictionary,
  mapCustomParamToCustomDimension,
  userPropertyToCustomDimensionDictionary,
} from './ga4Maps';
import type {
  CustomDimensionsOrParams,
  CustomDimensionToCustomParamMap,
  CustomDimensionToUserPropertyMap,
  CustomParams,
  CustomParamsUser,
  CustomParamToCustomDimensionMap,
  UserPropertyToCustomDimensionMap,
} from './ga4Types';

/**
 * Convert named GA4 custom parameters to legacy UA custom dimensions.
 * Use only during migration
 * @param params
 * @returns
 * @deprecated Use named GA4 custom parameters directly instead of converting them to UA dimensions.
 */
export const getCustomDimensionsFromParams = (
  params: CustomDimensionsOrParams = {}
): CustomDimensions => {
  return convertObjectByDictionaries<
    CustomDimensionsOrParams,
    CustomParamToCustomDimensionMap & UserPropertyToCustomDimensionMap,
    CustomDimensionToCustomParamMap | CustomDimensionToUserPropertyMap,
    CustomDimensions
  >(
    params,
    {
      ...userPropertyToCustomDimensionDictionary,
      ...mapCustomParamToCustomDimension,
    },
    {
      ...customDimensionToUserPropertyDictionary,
      ...customDimensionToCustomParamDictionary,
    }
  );
};

/**
 * Convert custom params (GA4) to custom dimensions (UA)
 * Use only during migration
 * @param params
 * @returns
 */
export const getCustomParamsFromDimensions = (
  params: CustomDimensionsOrParams = {}
): CustomParams => {
  return convertObjectByDictionaries<
    CustomDimensionsOrParams,
    CustomDimensionToCustomParamMap,
    CustomParamToCustomDimensionMap,
    CustomParams
  >(
    params,
    customDimensionToCustomParamDictionary,
    mapCustomParamToCustomDimension
  );
};

/**
 * Convert custom dimensions (UA) to user properties (GA4 / firebase)
 */
export const getUserPropertiesFromDimensions = (
  params: CustomDimensionsOrParams = {}
): CustomParamsUser => {
  return convertObjectByDictionaries<
    CustomDimensionsOrParams,
    CustomDimensionToUserPropertyMap,
    UserPropertyToCustomDimensionMap,
    CustomParamsUser
  >(
    params,
    customDimensionToUserPropertyDictionary,
    userPropertyToCustomDimensionDictionary
  );
};
